import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DattaConfig } from '../app-config';

import { DmhuyenthiDadt } from '../model/quanlythongtin/dmhuyenthidadt';
import { DmlinhvucDadt } from '../model/quanlythongtin/dmlinhvucdadt';
import { DmnguonkinhphiDadt } from '../model/quanlythongtin/dmnguonkinhphidadt';
import { Duankeugoidautu } from '../model/quanlythongtin/duankeugoidautu';

@Injectable({
  providedIn: 'root'
})
export class QlttDuankeugoiService {
  public dattaConfig: any;
  token: string;

  httpOptions : any;
  constructor(private httpClient: HttpClient) {
    this.dattaConfig = DattaConfig.config;   
  }
  ngOnInit(): void {
 
  }

  //dmhuyen
  getDmhuyenthiDadts() {
    return this.httpClient.get<DmhuyenthiDadt[]>(this.dattaConfig['httplink'] + '/dmhuyenthidadt/get');
  }

  addDmhuyenthiDadt(entity: DmhuyenthiDadt) {
    return this.httpClient.post<DmhuyenthiDadt>(this.dattaConfig['httplink'] + '/dmhuyenthidadt/add', entity);
  }

  updateDmhuyenthiDadt(entity: DmhuyenthiDadt){
    return this.httpClient.put<DmhuyenthiDadt>(this.dattaConfig['httplink'] + '/dmhuyenthidadt/update', entity);
  }

  deleteDmhuyenthiDadt(id) {
    return this.httpClient.delete<DmhuyenthiDadt>(this.dattaConfig['httplink'] + '/dmhuyenthidadt/'+id);
  }
  //end dmhuyen

  //dmlinhvuc
  getDmlinhvucDadts() {
    return this.httpClient.get<DmlinhvucDadt[]>(this.dattaConfig['httplink'] + '/dmlinhvucdadt/get');
  }

  getDmlinhvucDadtTheodonvis(id) {
    return this.httpClient.get<DmlinhvucDadt[]>(this.dattaConfig['httplink'] + '/dmlinhvucdadt/get/'+id);
  }

  addDmlinhvucDadt(entity: DmlinhvucDadt) {
    return this.httpClient.post<DmlinhvucDadt>(this.dattaConfig['httplink'] + '/dmlinhvucdadt/add', entity);
  }
  deleteDmlinhvucDadt(id) {
    return this.httpClient.delete<DmlinhvucDadt>(this.dattaConfig['httplink'] + '/dmlinhvucdadt/' + id);
  }
  updateDmlinhvucDadt(entity: DmlinhvucDadt) {
    return this.httpClient.put<DmlinhvucDadt>(this.dattaConfig['httplink'] + '/dmlinhvucdadt/update', entity);
  }
  //End dmlinhvuc

  //dmnguonkinhphi
  getDmnguonkinhphiDadts() {
    return this.httpClient.get<DmnguonkinhphiDadt[]>(this.dattaConfig['httplink'] + '/dmnguonkinhphidadt/get');
  }

  getDmnguonkinhphiDadtTheodonvis(id) {
    return this.httpClient.get<DmnguonkinhphiDadt[]>(this.dattaConfig['httplink'] + '/dmnguonkinhphidadt/get/'+ id);
  }

  addDmnguonkinhphiDadt(entity: DmnguonkinhphiDadt) {
    return this.httpClient.post<DmnguonkinhphiDadt>(this.dattaConfig['httplink'] + '/dmnguonkinhphidadt/add', entity);
  }
  deleteDmnguonkinhphiDadt(id) {
    return this.httpClient.delete<DmnguonkinhphiDadt>(this.dattaConfig['httplink'] + '/dmnguonkinhphidadt/' + id);
  }
  updateDmnguonkinhphiDadt(entity: DmnguonkinhphiDadt) {
    return this.httpClient.put<DmnguonkinhphiDadt>(this.dattaConfig['httplink'] + '/dmnguonkinhphidadt/update', entity);
  }
  //End dmnguonkinhphi

    //du an keu goi dau tu
    getDuankeugoidautus() {
      return this.httpClient.get<Duankeugoidautu[]>(this.dattaConfig['httplink'] + '/duankeugoidautu/get');
    }

    getDuankeugoidautuTheodonvis(id) {
      return this.httpClient.get<Duankeugoidautu[]>(this.dattaConfig['httplink'] + '/duankeugoidautu/get/'+id);
    }

    addDuankeugoidautu(entity: Duankeugoidautu) {
      return this.httpClient.post<Duankeugoidautu>(this.dattaConfig['httplink'] + '/duankeugoidautu/add', entity);
    }
    deleteDuankeugoidautu(id) {
      return this.httpClient.delete<Duankeugoidautu>(this.dattaConfig['httplink'] + '/duankeugoidautu/' + id);
    }
    updateDuankeugoidautu(entity: Duankeugoidautu) {
      return this.httpClient.put<Duankeugoidautu>(this.dattaConfig['httplink'] + '/duankeugoidautu/update', entity);
    }
    //End du an keu goi dau tu

}